
import * as defaultImport from "@splunk/visualization-color-palettes";
export * from "@splunk/visualization-color-palettes";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
